import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

import { MultiStepFormProvider } from '../../../providers/MultiStepForm.provider';
import { usePendingData } from '../../../providers/PendingData.provider';

import BillingPackageCreationForm from './BillingPackageCreationForm';
import BillingPackageCreationContext from './BillingPackageCreationContext';
import usePostCustomPackage from '../../../hooks/useApi/usePostCustomPackage';
import usePostCustomPackageDialogue from '../../../hooks/useDialogues/usePostCustomPackage.dialogue';
import useBillingPackageCreationFields from '@/hooks/useFields/useBillingPackageCreationFields';
import { useTranslation } from 'react-i18next';

const BillingPackageCreationContainer = (): React.JSX.Element => {
  const { hasPendingData } = usePendingData();
  const [response, sendRequest] = usePostCustomPackage({});
  const { destination, navigate, showDialogue } = usePostCustomPackageDialogue(response);
  const fields = useBillingPackageCreationFields();
  const { t } = useTranslation('translations', { keyPrefix: 'BillingPackage.Creation' });

  useEffect(() => {
    if (response.success || response.errorMessage) return showDialogue();
    return () => {};
  }, [response]);

  useEffect(() => {
    navigate();
  }, [destination]);

  return (
    <div>
      <MultiStepFormProvider context={BillingPackageCreationContext} fields={fields} onSubmit={sendRequest}>
        <BillingPackageCreationForm isComplete={Boolean(response.success)} />
      </MultiStepFormProvider>
      <Prompt when={hasPendingData} message={t('prompt')} />
    </div>
  );
};

export default BillingPackageCreationContainer;
